import { render, staticRenderFns } from "./clinicBinding.vue?vue&type=template&id=50ef2e9a&scoped=true"
import script from "./clinicBinding.vue?vue&type=script&lang=js"
export * from "./clinicBinding.vue?vue&type=script&lang=js"
import style0 from "./clinicBinding.vue?vue&type=style&index=0&id=50ef2e9a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ef2e9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50ef2e9a')) {
      api.createRecord('50ef2e9a', component.options)
    } else {
      api.reload('50ef2e9a', component.options)
    }
    module.hot.accept("./clinicBinding.vue?vue&type=template&id=50ef2e9a&scoped=true", function () {
      api.rerender('50ef2e9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dental/product/clinicBinding.vue"
export default component.exports